<template>
  <div class="modal-switch">
    <button
      v-for="button in buttons"
      :key="button.title"
      :class="[
        'modal-switch__button',
        { selected: activeGraphic === button.component },
      ]"
      @click="setActiveGraphic(button.component)"
    >
      {{ button.title }}
    </button>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "SwitchGraphics",
  props: {
    buttons: {
      type: Array,
    },
  },
  created() {
    this.setActiveGraphic(this.buttons[0].component);
  },
  computed: {
    ...mapGetters({
      activeGraphic: "ui/activeGraphic",
    }),
  },
  methods: {
    ...mapActions({
      setActiveGraphic: "ui/setActiveGraphic",
    }),
  },
};
</script>

<style lang="scss" scoped>
.modal-switch {
  width: 100%;
  height: $switch-drill-height;
  display: flex;
  justify-content: center;
  border-bottom: toRem(1) solid $white_02;

  &__button {
    text-transform: uppercase;
    color: $white_04;
    transition: color 0.3s ease;
    margin-right: toRem(50);
    @include filter-button;

    &.selected {
      color: var(--primary-yellow);
    }

    &:not(:first-of-type) {
      margin-right: 0;
    }
  }
}
</style>
